import React, {useContext, useState} from "react";
import "./TestApp.css";
import Devices from "./Devices";
import Row from "react-bootstrap/Row";
import Button from 'react-bootstrap/Button';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Accordion} from "react-bootstrap";
import {faLayerGroup, faPlay, faRotate, faSquare} from "@fortawesome/free-solid-svg-icons";
import Groups from "./Groups";
import Scenes from "./Scenes";
import Card from "react-bootstrap/Card";
import {useAccordionButton} from 'react-bootstrap/AccordionButton';
import AccordionContext from 'react-bootstrap/AccordionContext';

function TestApp({bond}) {
    const [reloadTimestamp, setReloadTimestamp] = useState(null);
    const [devicesById, setDevicesById] = useState({});

    function reload() {
        setReloadTimestamp(Date.now());
    }

    function CustomToggle({icon, label, eventKey}) {
        const {activeEventKey} = useContext(AccordionContext);

        const decoratedOnClick = useAccordionButton(eventKey, () => {
            if (!reloadTimestamp) reload();
        });
        const isCurrentEventKey = activeEventKey.indexOf(eventKey) >= 0;
        return (<Card.Header eventkey={eventKey} className={`accordion-button ${!isCurrentEventKey ? "collapsed" : ""}`}
                             onClick={decoratedOnClick}>
            <FontAwesomeIcon icon={icon} size="xl" className="iconAccordionHeader"/>{label}
            <Button variant={"outline-secondary"} className={"testAppBtnReload"} onClick={(e) => {
                e.stopPropagation();
                reload();
            }}><FontAwesomeIcon icon={faRotate}/></Button>
        </Card.Header>);
    }


    return (<Row>
        <Accordion defaultActiveKey={[]} alwaysOpen className={"testAppAccordion"}>
            <Card>
                <CustomToggle icon={faSquare} label={"Devices"} eventKey="0"/>
                <Accordion.Collapse eventKey="0">
                    <Card.Body className={"testAppBody"}>
                        <Devices bond={bond} reloadTimestamp={reloadTimestamp}
                                 setDevicesById={setDevicesById}/>
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
            <Card>
                <CustomToggle icon={faLayerGroup} label={"Groups"} eventKey="1"/>
                <Accordion.Collapse eventKey="1">
                    <Card.Body className={"testAppBody"}>
                        <Groups bond={bond} reloadTimestamp={reloadTimestamp} devicesById={devicesById}/>
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
            <Card>
                <CustomToggle icon={faPlay} label={"Scenes"} eventKey="2"/>
                <Accordion.Collapse eventKey="2">
                    <Card.Body className={"testAppBody"}>
                        <Scenes bond={bond} reloadTimestamp={reloadTimestamp}/>
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        </Accordion>
    </Row>);
}

export default TestApp;
